import dayjs from "dayjs";

export const ITEM_LEDGER_TABLE_HEADERS = [
  { id: "type", label: "Type" },
  { id: "entity_number", label: "Inv No/Bill No" },
  { id: "customer_name", label: "Customer Name" },
  { id: "location_name", label: "Location" },
  { id: "quantity", label: "Quantity" },
  { id: "rate", label: "Rate" },
  { id: "amount", label: "Amount" },
  { id: "is_returnable", label: "Returnable" },
  { id: "date", label: "Date" },
];

export const ITEM_LEDGER_FILTER_FIELDS = ITEM_LEDGER_TABLE_HEADERS;

export const RETURNABLE_OPTIONS = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "na" },
];

export const AMOUNT_OPTIONS = [
  { label: "Greater than 0", value: 0 },
  { label: "Greater than 1,000", value: 1000 },
  { label: "Greater than 10,000", value: 10000 },
  { label: "Greater than 1,00,000", value: 100000 },
  { label: "Greater than 10,00,000", value: 1000000 },
];

export const getUniqueFieldOptions = (rows, field) => {
  const seen = new Set();
  return (rows || [])
    .map((row) => row?.[field])
    .filter((value) => value != null && value !== "" && value !== "N/A")
    .filter((value) => {
      const key = String(value).trim();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => {
      const numA = Number(a);
      const numB = Number(b);
      if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
        return numA - numB;
      }
      return String(a).localeCompare(String(b));
    })
    .map((value) => ({ label: String(value), value: String(value) }));
};

export const filterItemLedgerRows = (rows, appliedFilters = {}) => {
  if (!appliedFilters?.filter_field || !rows?.length) {
    return rows || [];
  }

  const { filter_field, filter_value, date_from, date_to } = appliedFilters;

  return rows.filter((row) => {
    switch (filter_field) {
      case "type":
        return (
          String(row.type || "").toLowerCase() ===
          String(filter_value || "").toLowerCase()
        );

      case "entity_number":
        return String(row.entity_number || "")
          .toLowerCase()
          .includes(String(filter_value || "").toLowerCase());

      case "customer_name":
        return (
          String(row.customer_name || "").toLowerCase() ===
          String(filter_value || "").toLowerCase()
        );

      case "location_name":
        return (
          String(row.location_name || "").toLowerCase() ===
          String(filter_value || "").toLowerCase()
        );

      case "quantity":
        return String(row.quantity ?? "") === String(filter_value ?? "");

      case "rate":
        return String(row.rate ?? "") === String(filter_value ?? "");

      case "amount":
        return Number(row.amount) > Number(filter_value);

      case "is_returnable":
        if (filter_value === "na") {
          return row.is_returnable === null || row.is_returnable === undefined;
        }
        if (filter_value === "yes") {
          return row.is_returnable === true || row.is_returnable === 1;
        }
        if (filter_value === "no") {
          return row.is_returnable === false || row.is_returnable === 0;
        }
        return true;

      case "date": {
        if (!row.date) return false;
        const rowMonth = dayjs(row.date).format("YYYY-MM");
        if (date_from && rowMonth < dayjs(date_from).format("YYYY-MM")) {
          return false;
        }
        if (date_to && rowMonth > dayjs(date_to).format("YYYY-MM")) {
          return false;
        }
        return true;
      }

      default:
        return true;
    }
  });
};
